import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import {
  X2PropRecOnpInitModel,
  X2PropRecOnpInitVariables,
  X2PropRecOnpModel,
  X2PropRecOnpVariables,
} from '../../../../../models/email-template/x2-prop-rec-onp.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-x2-prop-rec-onp',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './x2-prop-rec-onp.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './x2-prop-rec-onp.component.scss'
})
export class X2PropRecOnpComponent extends BaseComponent implements OnInit {
  @Input() block: X2PropRecOnpModel = new X2PropRecOnpInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new X2PropRecOnpInitVariables()
    }
  }

  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image1HrefPlaceholder: string = 'Enter First Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Second Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  name1Placeholder: string = 'Enter First Name';
  name2Placeholder: string = 'Enter Second Name';
  ctaLink1Placeholder: string = 'Enter First CTA Link';
  ctaText1Placeholder: string = 'Enter First CTA Text';
  ctaLink2Placeholder: string = 'Enter Second CTA Link';
  ctaText2Placeholder: string = 'Enter Second CTA Text';
  oldPrice1Placeholder: string = 'Enter First Old Price';
  newPrice1Placeholder: string = 'Enter First New Price';
  oldPrice2Placeholder: string = 'Enter Second Old Price';
  newPrice2Placeholder: string = 'Enter Second New Price';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: keyof X2PropRecOnpVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof X2PropRecOnpVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
